import React, { useState, useEffect } from 'react';
import { flowRight } from 'lodash/fp';
import { withStyles } from '@material-ui/core';

import Access from 'ui/Access';
import PageContainer from 'ui/PageContainer';
import CompanyProfile from './components/CompanyProfile';
import PaymentsContact from './components/PaymentsContact';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import { withAppContext } from '../../../AppContext';
import { getPaymentInfo, patchPaymentInfo } from '../services';

const styles = theme => ({
    notification: {
        margin: '10px auto -50px',
    },

    notificationToolbar: {
        paddingRight: 0,
        paddingLeft: 16,
        background: '#a7ffeb',
        color: '#00bfa5',
    },
});

const Settings = ({ classes, app }) => {
    const [companyInfo, setCompanyInfo] = useState(null);
    const [paymentContact, setPaymentContact] = useState(null);

    useEffect(() => {
        getPaymentInfo().then(({ company_profile, payment_contact }) => {
            setCompanyInfo(company_profile);
            setPaymentContact(payment_contact);
        });
    }, []);

    const onSaveCompanyInfo = async data => {
        const { currency, country, ...rest } = data;
        await patchPaymentInfo({ company_profile: rest });
    };
    const onSavePaymentsContact = async data => {
        return await patchPaymentInfo({ payment_contact: data });
    };

    const [organization] = app.currentUser.organizations;

    const canEdit =
        app.currentUser.canChange(Access.ACCOUNT_DETAILS_PAYMENT_METHOD) &&
        organization.payment_method_setup;
    return (
        <React.Fragment>
            {!organization.payment_method_setup && (
                <PageContainer className={classes.notification}>
                    <Toolbar className={classes.notificationToolbar}>
                        <Typography
                            variant="subtitle1"
                            color="inherit"
                            noWrap
                            style={{ paddingRight: '0.5em' }}
                        >
                            Editing is disabled until payment method is entered.
                        </Typography>
                    </Toolbar>
                </PageContainer>
            )}
            {companyInfo && (
                <CompanyProfile
                    init={companyInfo}
                    onSubmit={onSaveCompanyInfo}
                    canEdit={canEdit}
                />
            )}
            {paymentContact && (
                <PaymentsContact
                    init={paymentContact}
                    onSubmit={onSavePaymentsContact}
                    canEdit={canEdit}
                />
            )}
        </React.Fragment>
    );
};

export default flowRight(withAppContext, withStyles(styles))(Settings);
